<template>
    <button :id="triggerButtonId" type="button" class="btn btn-primary" data-bs-toggle="modal"
        :data-bs-target="`#${modalContainerId}`" v-show="false"></button>

    <div class="modal fade" :id="modalContainerId" tabindex="-1" :aria-labelledby="modalLabelId" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-custom">
            <div class="modal-content d-flex flex-column modal-container">
                <div class="d-flex header justify-content-between">
                    <h1 class="modal-title fs-5" :id="modalLabelId">{{ props.header }}</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="footer d-flex justify-content-center">
                    <a type="button" class="btn add-to-cart-button align-self-end"
                        data-bs-dismiss="modal">{{ props.buttonText
                        }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { defineProps, defineExpose, computed } from 'vue';

const props = defineProps({
    header: {
        type: String,
        required: true
    },
    buttonText: {
        type: String,
        required: true
    }
});

// Generate a unique suffix for IDs to ensure instance isolation
const uniqueSuffix = Math.random().toString(36).substring(2, 9);

const triggerButtonId = computed(() => `alert_modal_button_${uniqueSuffix}`);
const modalContainerId = computed(() => `alert_modal_container_${uniqueSuffix}`);
const modalLabelId = computed(() => `alert_modal_label_${uniqueSuffix}`);

defineExpose({
    show
});

function show() {
    const modalButton = document.getElementById(triggerButtonId.value);
    modalButton?.click();
}

</script>

<style scoped>
.modal-dialog-custom {
    padding-left: 8px;
    padding-right: 8px;
}

.modal-container {
    padding: 16px;
    gap: 38px;
}

.header {
    font-family: 'Noto Sans TC', sans-serif;
    font-size: 16px;
    font-weight: 500;
}

.header * {
    display: inline;
}

.content {
    font-family: 'Noto Sans TC', sans-serif;
    font-size: 14px;
    font-weight: 400;
}

.add-to-cart-button {
    background-color: #FF057D;
    width: 160px;
    border-radius: 36px;
    padding-top: 12px;
    padding-bottom: 12px;
    font-family: 'Noto Sans', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: white;
}

.add-to-cart-button:hover {
    background-color: #CC4173;
    color: white;
}
</style>
